import { ITrainingBalanceResponse } from '@/types/views/trainingManagerConfiguration';
import { UseQueryOptions } from '@tanstack/react-query';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import { queryKeys } from './queryKeys';
import { useAppQuery } from './useAppQuery';

export const useTrainingBalance = (options?: Omit<UseQueryOptions<ITrainingBalanceResponse>, 'queryKey' | 'queryFn'>) => {
    const { data, ...rest } = useAppQuery<ITrainingBalanceResponse>('/TrainingManager/balances', {
        queryKey: queryKeys.trainingBalance.balance(),
        ...options
    });

    const amount = useMemo(() => {
        if (!isEmpty(data?.balances)) {
            return data?.balances.reduce((acc, balance) => acc + balance.currentAmountInCents, 0) || 0;
        }
        return 0;
    }, [data])

    const isUnlimitedCredit = useMemo(() => {
        if (!isEmpty(data?.balances)) {
            return data?.balances.some((balance) => balance.isUnlimitedCredit) || false;
        }
        return false;
    }, [data])

    return {
        amount,
        isUnlimitedCredit,
        balances: data?.balances || [],
        ...rest
    }
};